import { createDashHttpClient } from '@/apis/dash.http';
import { env } from '@/env';

export const http = createDashHttpClient(env.libraryApiUrl);

export default {
  async createProductCatalog({ brandId, source, sourceId }, config = {}) {
    const path = `/brands/${brandId}/product_catalog`;
    return http.post(path, { source, source_id: sourceId }, config);
  },

  async createProductFeed({ brandId, url = null, productCatalogId = null }, config = {}) {
    const path = `/brands/${brandId}/product_feeds`;
    return http.post(path, { url, product_catalog_id: productCatalogId }, config);
  },
};
